export const DEFAULT_TABLE_HEIGHT_WITH_ROWS = 200;
export const DEFAULT_TABLE_HEIGHT = 100;
export const DEFAULT_ROW_HEIGHT = 40;
export const AUTO_ROW_HEIGHT_MAX = 150;
export const TILE_VIEW_HEADER_HEIGHT = 27;
export const TILE_VIEW_ROW_HEIGHT = 36;
export const GAP_BETWEEN_GRID_TILES = 10;
export const GRID_CELL_TOP_PADDING = "8px";
export const GRID_CELL_BOTTOM_PADDING = "5px";
export const GRID_CELL_BLOCK_PADDING = parseInt(GRID_CELL_TOP_PADDING) + parseInt(GRID_CELL_BOTTOM_PADDING);

export const checkBoxStyle = {
    "& .rs-checkbox-inner:before": {
      border: "1px solid rgba(96, 96, 96) !important",
      borderRadius: "2px !important"
    },
    "&.rs-checkbox-disabled:not(.rs-checkbox-checked):not(.rs-checkbox-indeterminate) .rs-checkbox-wrapper .rs-checkbox-inner:before": {
      backgroundColor: "rgba(248, 248, 248, 0.4) !important",
      border: "1px solid rgba(96, 96, 96, 0.4) !important",
    },
    "&.rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner:before": {
      backgroundColor: "#0072c6 !important",
      border: "1px solid #0072c6 !important",
    },
    "&.rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner:before": {
      backgroundColor: "#0072c6 !important",
      border: "1px solid #0072c6 !important",
    }
  };

export const unwantdRowDataKeys = [
  "isShowTotal",
  "row_disabled",
  "id",
  "disabled_column_names",
  "cellBackGround",
  "row_visible"
];
